// @ts-nocheck
import {
  SET_UNREAD_NOTIFICATIONS_COUNT,
  FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_REQUEST,
  FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_SUCCESS,
  FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_FAILURE,
  NEW_TRIGGER_NOTE_NOTIFICATION,
} from "../constants/notifications";

const initialState = {
  notificationsCount: {
    readNotificationsCount: null,
    unreadNotificationsCount: null,
  },
  allNotifications: {
    data: [],
    isLoading: false,
  },
  unreadNotifications: {
    data: [],
    isLoading: false,
  },
  eventOneOnOneNotesOfAssignee: [],
  updatedChatMetaData: [],
  notesStatus: false,
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UNREAD_NOTIFICATIONS_COUNT: {
      return {
        ...state,
        notificationsCount: {
          ...state.notificationsCount,
          unreadNotificationsCount: action?.payload?.unreadNotificationsCount,
        },
      };
    }
    case FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_REQUEST:
      return {
        ...state,
        error: null,
        updatedChatMetaData: [],
      };
    case FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_SUCCESS:
      return {
        ...state,
        updatedChatMetaData: action.payload.data?.filter(
          (item) => item?.unreadMsgCount || item?.newAssigneeNoteCount,
        ),
        error: null,
      };
    case FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_FAILURE:
      return {
        ...state,
        error:
          action.payload || "Failed to get event one on one notes of assignee",
      };
    // case NEW_TRIGGER_NOTE_NOTIFICATION: {
    //   console.log(action.payload, state.updatedChatMetaData, "triggerreducer");
    //   const data = state.updatedChatMetaData?.find(
    //     (id) => id.eventId === action.payload.updatedChatMetaData.eventId,
    //   );
    //   if (data) {
    //     return {
    //       ...state,
    //       updatedChatMetaData: state?.updatedChatMetaData?.map((event) => {
    //         if (
    //           event?.eventId === action.payload?.updatedChatMetaData?.eventId
    //         ) {
    //           return {
    //             ...event,
    //             ...action.payload.updatedChatMetaData,
    //           };
    //         } else {
    //           return event;
    //         }
    //       }),
    //       error: null,
    //     };
    //   } else {
    //     return {
    //       ...state,
    //       updatedChatMetaData: [
    //         action?.payload?.updatedChatMetaData,
    //         ...state?.updatedChatMetaData,
    //       ],
    //     };
    //   }
    // }

    case NEW_TRIGGER_NOTE_NOTIFICATION: {
      const incomingEvent = action?.payload?.updatedChatMetaData;
      const updatedList = [];
      let found = false;

      state?.updatedChatMetaData?.forEach((event) => {
        if (event.eventId === incomingEvent.eventId) {
          found = true;
          updatedList.push({
            ...event,
            ...incomingEvent,
          });
        } else {
          updatedList.push(event);
        }
      });

      const newList = !found ? [incomingEvent, ...updatedList] : updatedList;

      // Only if the event was found, apply the filter to updatedChatMetaData
      const finalList = newList?.filter(
        (item) => item?.unreadMsgCount || item?.newAssigneeNoteCount,
      );

      return {
        ...state,
        updatedChatMetaData: finalList,
        error: null,
      };
    }

    case "UPDATE_NOTE_STATUS": {
      return {
        ...state,
        notesStatus: action?.payload,
      };
    }

    default:
      return state;
  }
};
export default notificationsReducer;
export { initialState };